export const UPDATE_TAXONOMY = 'UPDATE_TAXONOMY';
export const GET_TAXONOMY = 'GET_TAXONOMY';
